import * as _ from 'lodash';
import { DOWNLOAD_REQUESTED, DOWNLOAD_READY, DOWNLOAD_PROCESSED } from './download.actions';

export const Download = (state = {isNew: false, items: []}, action) => {
  switch (action.type) {
    case DOWNLOAD_REQUESTED:
      return {isNew: false, items: [...state.items]};
    case DOWNLOAD_PROCESSED:
      return {isNew: true, items: [{'code': action.code, 'type': action.name, 'status': 'PROCESSING'}, ...state.items]};
    case DOWNLOAD_READY:
      return {isNew: false, items: [
          {
            'code': action.code,
            'type': state.items.find(s => s.code === action.code).type,
            'status': 'READY'
          },
          ...state.items.filter(s => s.code !== action.code)
        ]};
    default:
      return state;
  }
};
